/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto } from './UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto';
import {
    UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoFromJSON,
    UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoFromJSONTyped,
    UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoToJSON,
} from './UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto';
import type { ConnectionStringsDto } from './ConnectionStringsDto';
import {
    ConnectionStringsDtoFromJSON,
    ConnectionStringsDtoFromJSONTyped,
    ConnectionStringsDtoToJSON,
} from './ConnectionStringsDto';

/**
 * 
 * @export
 * @interface UpdateConnectionStringsRequestDto
 */
export interface UpdateConnectionStringsRequestDto {
    /**
     * 
     * @type {ConnectionStringsDto}
     * @memberof UpdateConnectionStringsRequestDto
     */
    defaultConnectionString: ConnectionStringsDto;
    /**
     * 
     * @type {ConnectionStringsDto}
     * @memberof UpdateConnectionStringsRequestDto
     */
    blobStoringConnectionString: ConnectionStringsDto;
    /**
     * 
     * @type {UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto}
     * @memberof UpdateConnectionStringsRequestDto
     */
    maintenanceModeRequestDto?: UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateConnectionStringsRequestDto
     */
    backupConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateConnectionStringsRequestDto
     */
    $type?: UpdateConnectionStringsRequestDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateConnectionStringsRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDtoUpdateConnectionStringsRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Dto.UpdateConnectionStringsRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateConnectionStringsRequestDtoTypeEnum = typeof UpdateConnectionStringsRequestDtoTypeEnum[keyof typeof UpdateConnectionStringsRequestDtoTypeEnum];



/**
 * Check if a given object implements the UpdateConnectionStringsRequestDto interface.
 */
export function instanceOfUpdateConnectionStringsRequestDto(value?: unknown): value is UpdateConnectionStringsRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateConnectionStringsRequestDtoTypeEnum)[0];
}

export function UpdateConnectionStringsRequestDtoFromJSON(json: any): UpdateConnectionStringsRequestDto {
    return UpdateConnectionStringsRequestDtoFromJSONTyped(json, false);
}

export function UpdateConnectionStringsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConnectionStringsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'defaultConnectionString': ConnectionStringsDtoFromJSON(json['defaultConnectionString']),
        'blobStoringConnectionString': ConnectionStringsDtoFromJSON(json['blobStoringConnectionString']),
        'maintenanceModeRequestDto': json['maintenanceModeRequestDto'] == null ? undefined : UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoFromJSON(json['maintenanceModeRequestDto']),
        'backupConfirmed': json['backupConfirmed'] == null ? undefined : json['backupConfirmed'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UpdateConnectionStringsRequestDtoToJSON(value?: UpdateConnectionStringsRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultConnectionString': ConnectionStringsDtoToJSON(value['defaultConnectionString']),
        'blobStoringConnectionString': ConnectionStringsDtoToJSON(value['blobStoringConnectionString']),
        'maintenanceModeRequestDto': UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoToJSON(value['maintenanceModeRequestDto']),
        'backupConfirmed': value['backupConfirmed'],
        '$type': value['$type'],
    });
}

